// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Aw-z","tooltipWrapper":"Bw-z","icon":"Cw-z","tooltip":"Dw-z","content":"Ew-z"};